import styled from 'styled-components';

export const ContentModal = styled.div`
  padding-top: 30px;
  padding-bottom: 15px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ContentTitleModal = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  background-color: ${({ bgColor }) => bgColor};
  z-index: 99999;
`;

export const WrapperFields = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const BoxCenter = styled.div`
  display: flex;
  justify-content: center;
`;

export const ButtonWrapper = styled.div`
  padding-top: 10px;
  display: flex;
  gap: 20px;
`;

export const AlertWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
